const getters = {
  menuLists: state => state.app.menuLists,
  footerLists: state => state.app.footerLists,
  isMobile: state => state.app.isMobile
}
export default getters
